import { hooks } from 'botframework-webchat';
const { useActivities } = hooks;
const answerFeedbackEventName = 'answerFeedback';
export const useAnswerFeedbackProvided = (answerActivity) => {
    const [activities] = useActivities();
    for (const activity of activities) {
        if (activity.type === 'event' && activity.name === answerFeedbackEventName) {
            const value = activity.value;
            if (value.sourceActivityId === answerActivity.id) {
                return value;
            }
        }
    }
};
//# sourceMappingURL=useAnswerFeedbackProvided.js.map